import axios from "axios";
import { getDeviceId } from "./deviceId";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const id = getDeviceId();
  if (id) config.headers["X-Device-Id"] = id;
  return config;
});
